module.exports = __webpack_public_path__ + "static/media/CVE_logo_shadow.e3fbe1da.svg";